import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* ancillary(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/ancillary/' : config.credentials.url + '/ancillary/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "ANCILLARY_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "ANCILLARY_RESPONSE", value: error })
    }
}

function* ancillaries(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null)
            ? config.credentials.url + '/ancillary/list/?offset=0&limit=' + actions.limit
            : config.credentials.url + '/ancillary/list/' + actions.query;

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "ANCILLARIES_RESPONSE_LIST", value: response })
    } catch (error) {
        yield put({ type: "ANCILLARIES_RESPONSE_LIST", value: error })
    }
}

function* remove(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'delete', config.credentials.url + '/ancillary/' + actions.data + '/', requestOptions)

        yield put({ type: "ANCILLARY_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "ANCILLARY_RESPONSE", value: error })
    }
}

function* edit(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'PATCH', config.credentials.url + '/ancillary/' + actions.id + '/', requestOptions)
        response.view = 'edit'

        yield put({ type: "ANCILLARY_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "ANCILLARY_RESPONSE_ERROR", value: error })
    }
}

function* add(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const ancillaryResponse = yield call(apiCall, 'post', config.credentials.url + '/ancillary/', requestOptions);
        ancillaryResponse.view = 'create'
        yield put({ type: "ANCILLARY_RESPONSE", value: ancillaryResponse })
    } catch (error) {
        yield put({ type: "ANCILLARY_RESPONSE_ERROR", value: error })
    }
}

// function* hashExportAncillarys(actions) {
//     try {
//         const headers = {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${actions.access}`,
//         };
//         const requestOptions = {
//             headers: headers,
//         };

//         let url =
//             actions.query === null
//                 ? config.credentials.url + '/ancillary/report_coupons/?offset=0&limit=1000000'
//                 : config.credentials.url +
//                 '/ancillary/report_coupons/' +
//                 actions.query +
//                 '&offset=0&limit=100000';
//         const response = yield call(apiCall, 'get', url, requestOptions);

//         yield put({ type: 'HASH_EXPORT_ANCILLARIES_RESPONSE', value: response });
//     } catch (error) {
//         yield put({ type: 'HASH_EXPORT_ANCILLARIES_RESPONSE', value: error });
//     }
// }

// function* checkExportAncillarys(actions) {
//     try {
//         const headers = {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${actions.access}`,
//         };
//         const requestOptions = {
//             headers: headers,
//         };

//         const response = yield call(
//             apiCall,
//             'GET',
//             config.credentials.url + '/report/' + actions.hash + '/',
//             requestOptions
//         );

//         yield put({ type: 'REPORT_EXPORT_ANCILLARIES_RESPONSE', value: response });
//     } catch (error) {
//         yield put({ type: 'REPORT_EXPORT_ANCILLARIES_RESPONSE', value: error });
//     }
// }

export function* getAncillary() {
    yield takeEvery("GET_ANCILLARY", ancillary)
}

export function* getAncillariesList() {
    yield takeEvery("GET_ANCILLARIES", ancillaries)
}

export function* addAncillary() {
    yield takeEvery("ADD_ANCILLARY", add)
}

export function* editAncillary() {
    yield takeEvery("EDIT_ANCILLARY", edit)
}

export function* removeAncillary() {
    yield takeEvery("REMOVE_ANCILLARY", remove)
}

// export function* getHashExportAncillarysList() {
//     yield takeEvery('GET_HASH_EXPORT_ANCILLARIES', hashExportAncillarys);
// }

// export function* checkExportAncillarysList() {
//     yield takeEvery('CHECK_EXPORT_ANCILLARIES', checkExportAncillarys);
// }
